module.exports = __webpack_public_path__ + "static/media/gif carregando.d0f29dfb.gif";